import React from "react";
import { Modal, Form, Button } from "antd";
import dayjs from "dayjs";
import PaymentDataForm from "./PaymentDataForm";

// code-review F-09: DAT/TIM/DTM fields render antd DatePicker/TimePicker (see
// PaymentDataForm.js), whose form values are dayjs instances, not strings. Format
// each to the same pattern the picker displays before it reaches useOrderProcessing.js's
// metaData: {key, value} mapping -- otherwise the server stores a stringified dayjs
// object instead of the date/time the operator actually saw and entered.
const DATE_FORMATS = { DAT: "YYYY-MM-DD", TIM: "HH:mm:ss", DTM: "YYYY-MM-DD HH:mm:ss" };

// TSK-2934: generic payment-data capture popup, driven entirely by
// selectedPaymentMethod.paymentDataFields (from getTillData) instead of the
// Card-specific Till Template config used by CardPaymentModal/CardDetailsDrawer.
// Shared by Retail (SuperMarket/PreOrder/Estimate) and Restaurant.
const PaymentDataPopup = ({ open, selectedPaymentMethod, amount, currencySymbol, onSubmit, onCancel }) => {
  const [form] = Form.useForm();

  const fields = selectedPaymentMethod?.paymentDataFields || [];

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        const paymentData = fields
          .filter((f) => f.isactive === "Y" || f.isactive === true)
          .map((f) => {
            let displayValue;
            let fieldValue = values[f.fieldKey];
            if (f.fieldType === "LST") {
              const match = (f.listReference?.values || []).find((opt) => opt.value === fieldValue);
              displayValue = match?.name;
            } else if (DATE_FORMATS[f.fieldType] && dayjs.isDayjs(fieldValue)) {
              fieldValue = fieldValue.format(DATE_FORMATS[f.fieldType]);
            }
            return {
              fieldKey: f.fieldKey,
              fieldName: f.fieldName,
              fieldValue,
              displayValue,
            };
          })
          // Drop optional fields the cashier left blank -- previously these still
          // emitted a {fieldKey, value: undefined} metaData entry downstream.
          .filter((f) => f.fieldValue !== undefined && f.fieldValue !== null && f.fieldValue !== "");
        form.resetFields();
        onSubmit(paymentData);
      })
      .catch(() => {});
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      centered
      width="40%"
      footer={null}
      styles={{ body: { padding: 0 } }}
      closable={false}
      className="actionsModal"
      open={open}
      getContainer={false}
      zIndex={2000}
      destroyOnClose
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "24px",
          background: "#f3f4f9",
          borderRadius: "15px",
          padding: "6%",
        }}
      >
        <div>
          <p style={{ fontSize: "1.2rem", fontWeight: 500, textAlign: "left", width: "100%", margin: 0 }}>{selectedPaymentMethod?.name} Payment</p>
          <p style={{ paddingTop: "1.6vh", fontSize: "1rem", color: "#929098", fontWeight: 400, textAlign: "left", width: "100%", margin: 0 }}>
            Process {selectedPaymentMethod?.name} payment of {currencySymbol} {amount}
          </p>
        </div>

        <Form layout="vertical" form={form}>
          <PaymentDataForm fields={fields} />
        </Form>

        <div style={{ display: "flex", gap: "16px" }}>
          <Button
            size="large"
            style={{ flex: 1, height: "9vh", fontSize: "1.2vw", borderRadius: "8px" }}
            onClick={handleCancel}
          >
            Close
          </Button>
          <Button
            type="primary"
            size="large"
            style={{ flex: 1, height: "9vh", fontSize: "1.2vw", backgroundColor: "#2F3856", borderColor: "#2F3856", borderRadius: "8px", color: "#fff" }}
            onClick={handleOk}
          >
            Process Payment
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PaymentDataPopup;
